import * as React from 'react';
import { Switch } from 'react-router-dom';

// tslint:disable-next-line:no-unused-variable
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Sport from './sport';
import Book from './book';
import BookSubscription from './book-subscription';
/* jhipster-needle-add-route-import - JHipster will add routes here */

const Routes = ({ match }) => (
  <div className="page-shell">
    <Switch>
      {/* prettier-ignore */}
      <ErrorBoundaryRoute path={`${match.url}/sport`} component={Sport} />
      <ErrorBoundaryRoute path={`${match.url}/book`} component={Book} />
      <ErrorBoundaryRoute path={`${match.url}/book-subscription`} component={BookSubscription} />
      {/* jhipster-needle-add-route-path - JHipster will routes here */}
    </Switch>
  </div>
);

export default Routes;
